// [Archies] Product-card image arrows → fade carousel.
//
// The Archies card gallery stacks a product's images as overlaid .product-media-container elements
// (first shown, 2nd revealed on hover — that hover is the gender-metafield swap). It is NOT a
// horizontal scroller, so the slideshow-component's own next()/scroll is inert. This makes the
// prev/next arrows page through the stacked images by cycling which one is visible (opacity fade),
// while leaving the gender hover-swap intact until the shopper actually starts paging.
//
// - Clicks are caught in the capture phase and stopped, so the surrounding product <a> link never
//   fires (arrows page the image instead of navigating to the PDP).
// - Once the shopper pages, the card enters `.card-gallery--paged`: the current image is pinned
//   visible and the hover crossfade is suspended for that card (arrows are now in control).

(function () {
  if (window.__archiesCardArrowsWired) return;
  window.__archiesCardArrowsWired = true;

  const IMAGES = ':scope > .product-media-container, slideshow-slides > .product-media-container';

  function images(gallery) {
    // The stacked images live directly under slideshow-slides.
    const slides = gallery.querySelector('slideshow-slides');
    if (!slides) return [];
    let items = [...slides.children].filter((el) => el.classList.contains('product-media-container'));
    // Combined-listing cards also stack SIBLING colours' featured images (for the swatch picker).
    // Only page THIS product's own media (data-cg-own-ids = product.media ids).
    const own = (gallery.dataset.cgOwnIds || '').split(',').filter(Boolean);
    if (own.length) {
      const filtered = items.filter((el) => own.indexOf(el.getAttribute('slide-id')) !== -1);
      if (filtered.length) items = filtered;
    }
    return items;
  }

  function paint(gallery, index) {
    const items = images(gallery);
    const n = items.length;
    if (n < 2) return;
    const i = ((index % n) + n) % n;
    gallery.classList.add('card-gallery--paged');
    items.forEach((el, k) => el.classList.toggle('cg-current', k === i));
    gallery.dataset.cgIndex = String(i);

    // Reset to the original (metafield) first image + re-enable the hover-swap once the pointer
    // leaves the card. Wired once per card, on first paging.
    if (!gallery.__cgLeaveWired) {
      gallery.__cgLeaveWired = true;
      gallery.addEventListener('mouseleave', () => reset(gallery));
    }
  }

  function reset(gallery) {
    gallery.classList.remove('card-gallery--paged');
    images(gallery).forEach((el) => el.classList.remove('cg-current'));
    delete gallery.dataset.cgIndex;
  }

  // Don't let a mouse press focus the arrow — otherwise Chrome flags the click as keyboard-like and
  // paints the :focus-visible ring (which then lingers). Preventing the mousedown default keeps focus
  // (and the ring) keyboard-only, while the click itself + the :active press feedback still fire.
  document.addEventListener(
    'mousedown',
    (event) => {
      if (event.target.closest('.card-gallery__arrows-ext .slideshow-control')) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest('.card-gallery__arrows-ext .slideshow-control');
      if (!control) return;
      const gallery = control.closest('.card-gallery');
      if (!gallery) return;

      // Don't let the click reach the product link or Horizon's (inert here) slideshow handler.
      event.preventDefault();
      event.stopPropagation();

      const dir = control.classList.contains('slideshow-control--previous') ? -1 : 1;
      const current = parseInt(gallery.dataset.cgIndex || '0', 10);
      paint(gallery, current + dir);

      // Mouse/touch click (event.detail > 0): drop focus so the keyboard-only focus ring doesn't
      // linger after the pointer moves away. Keyboard activation (Enter/Space → detail 0) keeps
      // focus + ring, which is required for 2.4.7.
      if (event.detail > 0) control.blur();
    },
    true // capture — beat the anchor + delegated handlers
  );

  // Hide the arrows on cards that have fewer than 2 of their OWN images (nothing to page).
  function initArrowVisibility(root) {
    (root || document).querySelectorAll('.card-gallery:has(.card-gallery__arrows-ext)').forEach((gallery) => {
      const arrows = gallery.querySelector('.card-gallery__arrows-ext');
      if (arrows) arrows.style.display = images(gallery).length < 2 ? 'none' : '';
    });
  }
  initArrowVisibility();
  document.addEventListener('DOMContentLoaded', () => initArrowVisibility());
  // Collection grid swaps (pills/filters) replace the cards — re-check then too.
  document.addEventListener('collection:pills:swapped', () => initArrowVisibility());
})();
